import { endpoints } from '@api'
import { useToast } from '@chakra-ui/react'
import { trackEvent } from '@lib/clinician-tracking'
import { copyToClipboard } from '@utilities'
import { useMemo } from 'react'
import { useQuery } from 'react-query'
export const useTelehealthLinks = () => {
  const { data: user }: { data: any } = useQuery(
    endpoints.getUserAccount.getCacheId(),
    () => endpoints.getUserAccount.request()
  )

  const toast = useToast()

  const telehealthDomain = useMemo(() => {
    if (process.env.REACT_APP_ENV !== 'production') {
      return window.location.origin
    } else {
      return 'https://meet.blueprint.ai'
    }
  }, [])

  const telehealthUrl = useMemo(() => {
    return `${telehealthDomain}/with/${user?.display_id}`
  }, [telehealthDomain, user?.display_id])

  const telehealthUrlDisplay = useMemo(() => {
    return telehealthUrl.replace('https://', '')
  }, [telehealthUrl])

  const copyLinkToClipboard = () => {
    try {
      copyToClipboard(telehealthUrl)
      trackEvent('click:telehealth-session.copy-link-to-clipboard')
      toast({
        title: 'Telehealth URL copied to clipboard!',
        status: 'success',
        isClosable: true,
        containerStyle: {
          zIndex: 999
        },
        position: 'top-right'
      })
    } catch (e) {
      toast({
        title: 'Error',
        description:
          "We're sorry, something went wrong, please refresh and try again",
        status: 'error',
        isClosable: true,
        containerStyle: {
          zIndex: 999
        },
        position: 'top-right'
      })
    }
  }

  return {
    copyLinkToClipboard,
    telehealthUrl,
    telehealthUrlDisplay
  }
}
